import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-request-barcode',
  templateUrl: './request-barcode.component.html',
  styleUrls: ['./request-barcode.component.css']
})
export class RequestBarcodeComponent implements OnInit {

  @Input() public barcodeImage: RequestBarcodeImage;

  public imageSource: string;

  constructor() { }

  ngOnInit() {
    if (!this.barcodeImage) {
      return;
    }

    if (!this.barcodeImage.imageFormat) {
      throw new Error();
    }

    if (!this.barcodeImage.base64EncodedBytes) {
      throw new Error();
    }

    this.imageSource = `data:${this.barcodeImage.imageFormat};base64,${this.barcodeImage.base64EncodedBytes}`;
  }

}

export interface RequestBarcodeImage {
  imageFormat: string;
  base64EncodedBytes: string;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/request-barcode/request-barcode.component.ts